<template>
  <div class="email-step">
    <h2>Let's Start With Your Email</h2>
    <div class="form-group">
      <label>Email Address</label>
      <div class="email-input" v-if="!emailVerified">
        <input v-model="email" :disabled="emailVerified || emailSent" type="email" placeholder="your@email.com" />
        <button v-if="!emailSent" @click="sendVerification" :disabled="!isValidEmail || loading">
          VERIFY
        </button>
        <div v-if="emailSent">
          Verification Email Sent
        </div>
      </div>
      <div v-if="emailVerified">
        <div class="verified-message">
          <div>
            {{ email }}
          </div>
          <span><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8.12988" r="8" fill="#42C0C0" />
              <path d="M4 7.76923L7.11538 10.8846L13 5" stroke="white" stroke-width="1.38462" />
            </svg>

            email verified</span>
        </div>
      </div>



      <div v-if="emailSent && !emailVerified" class="email-verify-input">

        <div class="code-input">
          <input v-model="code" placeholder="Enter verification code from email" maxlength="6" />
          <button @click="validateCode" :disabled="!code || loading">
            VALIDATE
          </button>
        </div>
      </div>
    </div>
    <div class="step-footer">
      <span>Step 1 of 8</span>
      <button class="next-btn" @click="nextStep" :disabled="!emailVerified">
        NEXT
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailStep",
  emits: ["nextStep"],
  data() {
    return {
      email: "",
      code: "",
      emailSent: false,
      emailVerified: false,
      loading: false,
    };
  }, computed: {
    isValidEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.email);
    },
  },
  methods: {
    async sendVerification() {
      this.loading = true;
      try {
        // Call backend to send verification email
        // const res = await fetch("/api/registration/send-code", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({ email: this.email }),
        // });

        // if (!res.ok) throw new Error("Failed to send code");

        this.emailSent = true;
      } catch (err) {
        alert("Failed to send verification email.");
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    async validateCode() {
      this.loading = true;
      try {
        // const res = await fetch("/api/registration/verify-code", {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //   },
        //   body: JSON.stringify({
        //     email: this.email,
        //     code: this.code,
        //   }),
        // });

        // const result = await res.json();
        // if (!res.ok || !result.valid) throw new Error("Invalid code");

        this.emailVerified = true;
      } catch (err) {
        alert("Verification failed.");
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    nextStep() {
      this.$emit("nextStep", {
        email: this.email,
        emailVerified: this.emailVerified,
      });
    },
  },
};
</script>

<style scoped>
.email-step {
  max-width: 500px;
  margin: 0 auto;
  display: grid;
  grid-template-rows: 1fr 8fr 1fr;

  h2 {
    border-bottom: SOLID 1PX #E0E0E0;
  }
}

.form-group {
  padding-top: 1.5%;
}

.email-input,
.code-input {
  display: grid;
  gap: 10px;
  grid-template-columns: 2fr 1fr;
  margin-bottom: 10px;
}

input[type="email"],
input[type="text"] {
  flex: 1;
  padding: 8px;
  font-size: 16px;
}

button {
  padding: 8px 14px;
  cursor: pointer;
}

.next-btn {
  background-color: #42C0C0;
  color: white;
  border: none;
}

.next-btn:disabled {
  background-color: #8adbdb;
  cursor: not-allowed;
  opacity: 0.6;
}

.verified-message {
  font-weight: bold;
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 15px;
  div{
        position: relative;
      top: 5px;
  }
  span {

    color: #42C0C0;
  }

  svg {
    position: relative;
    top: 4px;
  }

}

.step-footer {
  display: grid;
  grid-template-columns: 4fr 1fr;
  border-top: SOLID 1PX #E0E0E0;
  padding: 5px 0;

  span {
    padding-top: 2%;
  }
}
</style>
